export default __webpack_public_path__ + "e0223fe4fb7e0b7936a9cb8eb94c50cc.jpg";